import { Group } from "@mantine/core";
import sharedStyles from "@/common-ui/sharedStyles.module.css";

export function CheckmarkBounce() {
    return (
        <Group
            justify="center"
            bdrs="50%"
            gap="sm"
            w="5rem"
            h="5rem"
            pos="relative"
            style={{ borderWidth: "2px", borderStyle: "solid", borderColor: "var(--mantine-color-success-5)" }}
        >
            <svg
                width="36"
                height="36"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={sharedStyles.animateCheckmarkBounce}
            >
                <path
                    d="M5 13L9 17L19 7"
                    stroke="var(--mantine-color-success-5)"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                ></path>
            </svg>
        </Group>
    );
}
